<template>
  <ContentWrapper>
    <v-row no-gutters>
      <v-col
          v-for="(manager, i) in managers"
          :key="i"
          cols="12"
          sm="12"
          lg="4"
      >
        <Manager :manager="manager">
        </Manager>
      </v-col>
    </v-row>
  </ContentWrapper>
</template>
<script>
import Manager from "../components/Manager";
import ContentWrapper from "../components/ContentWrapper";

export default {
  components: {Manager, ContentWrapper},
  mounted() {
    this.$store.commit('SET_TITLE', 'Der Vorstand')
  },
  data() {
    return {
      managers: [
        {
          name: "Axel Xaver Neigenfink",
          position: "Vorsitzender",
          img: "neigenfink.jpg",
          email: "vorsitzender@etc-ellerau.de",
          telephone: "0176/87949746"
        },
        {
          name: "Ulrike Lentzsch",
          position: "2. Vorsitzende",
          img: "ulrike_lentzsch.jpg",
          email: "ulrike@familielentzsch.de",
          telephone: "0162/9074721"
        },
        {
          name: "Matthias Kolb",
          position: "Finanzen",
          img: "profile.png",
          email: "kasse@etc-ellerau.de",
          telephone: "0171/3664468"
        },
        {
          name: "Carsten Walter",
          position: "Sportwart",
          email: "sport@etc-ellerau.de",
          telephone: "0178/1844871",
          img: "carsten_w.jpeg"
        },
        {
          name: "Pauline Seidel",
          position: "Jugendwärtin",
          email: "jugendarbeit@etc-ellerau.de",
          img: "pauline_seidel.jpeg"
        },
        {
          name: "Jens Kuchenbecker",
          position: "Liegenschaftswart",
          email: "liegenschaften@etc-ellerau.de",
          telephone: "0174/4256780",
          img: "jens_kuchenbecker.jpeg"
        },
      ]
    }
  }
}
</script>
